import { Component } from '@angular/core';

@Component({
	selector: 'app-transport-leads-list-filters',
	templateUrl: './transport-leads-list-filters.component.html',
	styleUrls: ['./transport-leads-list-filters.component.css'],
})
export class TransportLeadsListFiltersComponent {
	constructor() {}
}
